export const GREEN = '#0f9d58';
export const RED = '#ef5350';
